import {createAction, createReducer} from '@reduxjs/toolkit';

import {INITIAL_FORM_VALUES} from 'desktop/pages/checkout/constants/checkout';
import {AddressType} from 'desktop/pages/success/types/types';

export const initialState: AddressType = {...INITIAL_FORM_VALUES};

export const saveShippingAddress = createAction<AddressType>('CHECKOUT@SAVE_SHIPPING_ADDRESS');

/**
 * Shipping address reducer
 *
 * @return {AddressType} reducer shipping addresses
 */
export const shippingAddress = createReducer(initialState, builder =>
    builder.addCase(saveShippingAddress, (state, action) => ({
        ...state,
        ...action.payload,
    })),
);
